import { createAsyncThunk } from "@reduxjs/toolkit";
import type { UserLicenseAssignmentState } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchLicenseAssignmentErrors = createAsyncThunk(
	"licenses/fetchLicenseAssignmentErrors",
	apiGet<UserLicenseAssignmentState[]>(
		(authConfig) => authConfig.MS_GRAPH_API_ENDPOINTS.GET_LICENSE_ASSIGNMENT_ERRORS(),
		[SCOPES.GRAPH_READ],
	),
);

export const fetchLicenseAssignmentErrorsForUser = createAsyncThunk(
	"licenses/fetchLicenseAssignmentErrorsForUser",
	apiGet<UserLicenseAssignmentState>(
		(authConfig, { id }) =>
			authConfig.MS_GRAPH_API_ENDPOINTS.GET_LICENSE_ASSIGNMENT_ERRORS_FOR_USER(id),
		[SCOPES.GRAPH_READ],
	),
);
